import axios from "axios";
import {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError,
} from "axios";

// src/api/interceptors.js
interface RetryableAxiosRequestConfig extends AxiosRequestConfig {
  _retry?: boolean;
}

export const setupInterceptors = (axiosInstance: AxiosInstance): void => {
  // Request Interceptor: Attach Authorization Token
  axiosInstance.interceptors.request.use(
    (config: any): any => {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
        config.headers["userId"] =
          localStorage.getItem("userId") || "62c80ab36fd2b36bfe5b024b";
      }
      return config;
    },
    (error: AxiosError): Promise<AxiosError> => Promise.reject(error)
  );

  // Response Interceptor: Handle Errors
  // axiosInstance.interceptors.response.use(
  //   (response: AxiosResponse): AxiosResponse => response,
  //   async (error: AxiosError): Promise<AxiosResponse | Promise<never>> => {
  //     const originalRequest: RetryableAxiosRequestConfig =
  //       error.config as RetryableAxiosRequestConfig;
  //     if (error.response?.status === 401 && !originalRequest._retry) {
  //       originalRequest._retry = true;
  //       // Assume a refreshToken function to handle token renewal
  //       const newToken = await refreshTokens(axiosInstance);
  //       if (newToken && newToken.data.tokens.access.token) {
  //         axiosInstance.defaults.headers.common[
  //           "Authorization"
  //         ] = `Bearer ${newToken.data.tokens.access.token}`;
  //         return axiosInstance(originalRequest);
  //       }
  //     }
  //     return Promise.reject(error);
  //   }
  // );
};

// Optional: refresh token function
export const refreshTokens = async (axiosInstance: any) => {
  const refreshToken = localStorage.getItem("refreshToken");
  if (!refreshToken) {
    console.error("No refresh token available");
    return null;
  }

  try {
    const response = await axiosInstance.post("/auth/refresh-tokens", {
      refreshToken: refreshToken,
    });
    localStorage.setItem("token", response.data.tokens.access.token);
    localStorage.setItem("userId", response.data.user._id);
    localStorage.setItem("user", JSON.stringify(response.data.user));
    return response;
  } catch (error) {
    console.error("Token refresh failed", error);
    // Optionally handle logout or redirect to login
    return null;
  }
};
